export default __webpack_public_path__ + "static/media/kitchen-pack-14.e0421c99.png";